import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c596fe74"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c596fe74')) {
      api.createRecord('c596fe74', component.options)
    } else {
      api.reload('c596fe74', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c596fe74", function () {
      api.rerender('c596fe74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/evaluations/vipClassroomInfo/vipLevel/index.vue"
export default component.exports